module.exports = __webpack_public_path__ + "img/img-feature-title.4c80ff26.png";